import { FieldType, FieldEntity } from '__core/shared/model/field/Field.enum';
import Field from '__core/shared/model/field/Field';
import stFieldEdit from './fieldEdit.component';
import fieldsController from './fields.controller';
import stFieldsList from './fieldsList.component';

export default angular
  .module('st.Field', ['st.Core', 'angular-cache'])
  .factory('Field', () => Field)
  .factory('FieldType', () => FieldType)
  .factory('FieldEntity', () => FieldEntity)
  .component('stFieldEdit', stFieldEdit)
  .controller('fieldsController', fieldsController)
  .component('stFieldsList', stFieldsList)
  .service('fieldService', (Field, FieldType, dataService) => {
    const getFieldTypeIcon = (fieldType) => {
      let icon = 'font_download';
      switch (fieldType) {
        case FieldType.options_multiple:
          icon = 'check_box';
          break;
        case FieldType.options_single:
          icon = 'radio_button_checked';
          break;
        case FieldType.number:
          icon = 'looks_one';
          break;
        case FieldType.money:
          icon = 'attach_money';
          break;
        case FieldType.phone:
          icon = 'call';
          break;
        default:
          break;
      }
      return icon;
    };
    const getCustomField = (customField) => {
      if (customField.type.name === FieldType.options_multiple.name) {
        return _.reduce(
          _.zip(customField.fieldOptions(), customField.value),
          (memo, op) => (memo += op[1] === true ? (memo !== '' ? ', ' : '') + op[0] : ''),
          ''
        );
      } else {
        return customField.value;
      }
    };
    return {
      getFieldTypeIcon,
      getCustomField,
      createField: (doc) => dataService.createDocument(Field, doc),
      readField: (doc) => dataService.readDocument(Field, doc),
      updateField: (doc) => dataService.updateDocument(Field, doc),
      deleteField: (doc) => dataService.deleteDocument(Field, doc)
    };
  })
  .service('fieldsService', ($http, $rootScope, CacheFactory, dataService, Field, FIELD) => {
    let cache;
    if (!CacheFactory.get(FIELD.CACHE.NAME)) {
      cache = CacheFactory(FIELD.CACHE.NAME, FIELD.CACHE.STORE);
    }
    const cacheKey = (params, requestName) =>
      JSON.stringify({
        idAccount: $rootScope.CurrentAccount.id,
        idOrganization: $rootScope.CurrentOrganization.id,
        type: requestName || FIELD.CACHE.NAME,
        params
      });
    return {
      clearCache: () => cache.removeAll(),
      getAvailable: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getAvailable'),
          params?.ignoreCache === true,
          Field.build,
          $http.get,
          FIELD.API.AVAILABLE,
          { params }
        )
    };
  })
  .constant('FIELD', {
    API: {
      AVAILABLE: '/api/v1/fields/available/'
    },
    CACHE: {
      NAME: 'fieldsCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
